import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";
import { useResolvedDisplayName } from "../../../user/useResolvedDisplayName";
import { useWhoAmI } from "../../../user/useWhoAmI";
import { concatClassnames } from "../../../utils/util";

export interface DepartmentTemplateProps {
  isTopBar?: boolean;
}

export const DepartmentTemplate = withWSErrorContainer(
  observer((props: DepartmentTemplateProps) => {
    const { isTopBar } = props;
    const { whoAmI, confirmedHasVerifiedProfileInConcern } = useWhoAmI();
    const L = useLocStore(LocContext.PROFILE);

    const profileName = useResolvedDisplayName() ?? "";

    let mainText = "";

    if (confirmedHasVerifiedProfileInConcern) {
      mainText = whoAmI.details.concernName;
    } else if (!isTopBar) {
      mainText = L.id("8a8024b319b8").loc("Dine profiler");
    }

    return (
      <StyledDepartmentTemplate
        className={concatClassnames([
          "cvp-department-template",
          isTopBar && "top-bar",
        ])}
      >
        <div className="department-template_left">
          {!isTopBar && <i className="pi pi-fw pi-building" />}
          {isTopBar && <i className="pi pi-fw pi-angle-down" />}
          <div className="department-template_left--names">
            {!!mainText && (
              <>
                {isTopBar && <div className="user-name">{profileName}</div>}
                <div className="department">{mainText}</div>
              </>
            )}
            {!mainText && <div className="user-name-only">{profileName}</div>}
          </div>
        </div>
        {!isTopBar && (
          <div className="department-template_right">
            <i className="pi pi-fw pi-angle-right"></i>
          </div>
        )}
      </StyledDepartmentTemplate>
    );
  })
);

const StyledDepartmentTemplate = styled.div`
  &.cvp-department-template {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
    padding: 0.9rem 1rem;
    background-color: var(--primary-100-relative);
    width: 100%;

    &:hover {
      color: var(--primary-500-relative);
      background: var(--primary-100-relative);
      -webkit-transition: all ease-out 0.3s;
      -moz-transition: all ease-out 0.3s;
      -o-transition: all ease-out 0.3s;
      transition: all ease-out 0.3s;
      cursor: pointer;
    }

    .department-template_left {
      display: flex;
      align-items: center;
      overflow: hidden;
      i {
        font-size: 1em;
        margin-right: 0.5rem;
      }
    }

    .department-template_left--names {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      overflow: hidden;

      .user-name {
        font-weight: 500;
        font-size: 0.7em;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .user-name-only {
        font-weight: 500;
        font-size: 0.8em;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .department {
        font-weight: 500;
        font-size: 0.8em;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .department-template_right {
      display: flex;
      align-items: center;
      i {
        font-size: 1em;
      }
    }

    &&.top-bar {
      padding: 0;
      background-color: var(--surface-card);
      white-space: nowrap;
      overflow: hidden;
    }
  }
`;
